import { useAuthContext } from '../../contexts/AuthContext';
import type { AuthContextType } from '../../contexts/AuthContext';

// Re-export the context hook directly since all functionality is now in AuthContext
export const useAuth = useAuthContext;

export type { AuthContextType };
export default useAuth;
